import { render, staticRenderFns } from "./system-config.vue?vue&type=template&id=610b9082&scoped=true&"
import script from "./system-config.vue?vue&type=script&lang=js&"
export * from "./system-config.vue?vue&type=script&lang=js&"
import style0 from "./system-config.vue?vue&type=style&index=0&id=610b9082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b9082",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610b9082')) {
      api.createRecord('610b9082', component.options)
    } else {
      api.reload('610b9082', component.options)
    }
    module.hot.accept("./system-config.vue?vue&type=template&id=610b9082&scoped=true&", function () {
      api.rerender('610b9082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-account-management/system-config.vue"
export default component.exports